import { Badge, Nav } from "react-bootstrap";
import styles from '../../styles/NavBar.module.css';
import { useShopContext } from "../../context/ShopContext";
import { Link } from "react-router-dom";

const NavCart = () => {

    const { cartItems } = useShopContext();

    const cartCount = () => {
        const items = cartItems.filter((item) => (
            item.AMOUNT > 0 ? item : null)).length;
        return items;
    };

    return (
    <>
        <Nav className="align-middle order-3 order-sm-3 p-0 d-block d-lg-none">
        <Nav.Link as={Link} to="/cart">
            Καλάθι <Badge bg="light" className={styles.Badge}>{cartCount()}</Badge>
        </Nav.Link>
    </Nav>
    <Nav className="align-middle order-3 order-sm-3 px-3 d-none d-lg-block">
        <Nav.Link as={Link} to="/cart" className={styles.Cart}>
        <span className={`${styles.cartBadge} ${cartCount() > 0 ? "visible" : "invisible"}`}>{cartCount()}</span>
        </Nav.Link>
    </Nav>
    </>
    );
};

export default NavCart;